import { useState, useEffect } from 'react'
import cookies from 'js-cookie'
import jwt from 'jsonwebtoken'

// Decode the auth cookie and treat an expired (or legacy exp-less) token as
// logged-out. Without this, jwt.decode happily returns the payload of a stale
// token, the app renders as authenticated, and every server call fails with
// "Not Authorised!". Clearing the stale cookie also stops the request link from
// sending an invalid Authorization header, so the user lands cleanly on login.
const decodeValidToken = () => {
  const raw = cookies.get('token')
  if (!raw) return null
  const decoded = jwt.decode(raw)
  if (!decoded || !decoded.exp || Date.now() / 1000 > decoded.exp) {
    cookies.remove('token')
    return null
  }
  return decoded
}

export default () => {
  const [token, setToken] = useState(decodeValidToken)

  useEffect(() => {
    const onStorageEvent = ({ key }) => {
      if (key === 'login') setToken(decodeValidToken())
    }
    window.addEventListener('storage', onStorageEvent)

    return () => window.removeEventListener('storage', onStorageEvent)
  }, [])

  return token
}
